import React from 'react';

import {formatDate} from "utils";

import { HygienistBackendJob } from "components/EditJob";

import {
  JobContainer,
  TitlesContainer,
  Title,
  Subtitle,
  NewCandidatesInfo,
  PersonOutlineIconStyled,
  JobInfoContainer,
  JobInfoItem,
  CalendarTodayOutlinedIconStyled,
  StartingDate,
  Badge,
  StyledEliteImage,
  StyledProImage
} from './JobList.styles'

interface JobListItemProps {
  job: HygienistBackendJob,
  onJobClick: (job: HygienistBackendJob) => void
}

const HygienistJobListItem = ({ job, onJobClick }: JobListItemProps) => {
  const {
    title,
    id,
    location,
    isApplied,
    startDate,
  } = job;

  const NewCandidatesBadge = isApplied ? (
    <NewCandidatesInfo>
      <PersonOutlineIconStyled />
      <span>Applied</span>
    </NewCandidatesInfo>
  ) : null;

  return (
    <JobContainer
      key={id}
      onClick={() => onJobClick(job)}
      className='no-fastclick'
    >
      <TitlesContainer>
        <div>
          <Title>{title}</Title>
          <Subtitle>
            <span>{[location?.address, location?.city, location?.province].filter(Boolean).join(', ')}</span>
            <Badge>
              {location.status === 1 && <StyledProImage />}
              {location.status === 2 && <StyledEliteImage />}
            </Badge>
          </Subtitle>
        </div>
        {NewCandidatesBadge}
      </TitlesContainer>
      <JobInfoContainer>
        <JobInfoItem>
          <CalendarTodayOutlinedIconStyled />
          <b>Starting</b>
          <StartingDate $isHygienist={true}>
            {startDate ? (new Date(startDate) <= new Date() ? ' Immediately' : formatDate(startDate)) : ''}
          </StartingDate>
        </JobInfoItem>
      </JobInfoContainer>
    </JobContainer>
  )
}

export default HygienistJobListItem;
